import { endOfDay, startOfDay, subDays } from 'date-fns'

import { createSlice } from '../zustandHelpers'
import { IDashboardActions, IDashboardState } from './dashboard.slice.interface'
import { toastError } from '../../../infrastructure/hooks/useToast'
import { t } from '../../../infrastructure/translation/customTranslation'

export const dashboardSlice = createSlice<IDashboardState, IDashboardActions>((set) => ({
  loading: false,
  dashboardData: null,
  power: null,
  salesRevenue: null,
  error: null,

  setDashboardData: async (dashboardData) => {
    try {
      set({ dashboardData, error: null })
    } catch (error) {
      toastError(t('connection_error'))
      set((state) => ({
        error: [...(state.error || []), 'Error retrieving data'],
      }))
    }
  },

  setPower: async (power) => {
    try {
      set({ power, error: null })
    } catch (error) {
      toastError(t('connection_error'))
      set((state) => ({
        error: [...(state.error || []), 'Error retrieving power data'],
      }))
    }
  },

  setSalesRevenue: async (salesRevenue) => {
    try {
      set({ salesRevenue, error: null })
    } catch (error) {
      toastError(t('connection_error'))
      set((state) => ({
        error: [...(state.error || []), 'Error retrieving revenue data'],
      }))
    }
  },
  setDashboardDataLoading: (loading) => {
    set({ loading })
  },
  resetDashboard: () => {
    set(() => ({
      loading: false,
      salesRevenueLoading: false,
      powerLoading: false,
      dashboardData: null,
      power: null,
      salesRevenue: null,
      expectedData: null,
      dates: {
        start: startOfDay(subDays(new Date(), 1)).valueOf(),
        end: endOfDay(subDays(new Date(), 1)).valueOf(),
      },
      interval: 60,
      error: null,
    }))
  },
}))
